<div class="h-full rounded-lg p-6 border border-border space-y-4">
  <h2 class="text-2xl font-semibold">{{ properties().name }}</h2>
  <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-16 gap-y-2">
    <div>
      <p class="text-text-secondary">Booking period</p>
      <p>
        {{ properties().projectPeriod.start | date: 'dd/MM/yyyy' }} -
        {{ properties().projectPeriod.end | date: 'dd/MM/yyyy' }}
      </p>
    </div>
    <div>
      <p class="text-text-secondary">Duration</p>
      <p>{{ properties().projectPeriod.formatted }}</p>
    </div>
    <div>
      <p class="text-text-secondary">Country</p>
      <p>{{ properties().country }}</p>
    </div>

    @for (prop of dynamicProperties(); track prop.label) {
      <div>
        <p class="text-text-secondary">{{ prop.label }}</p>
        <p>{{ prop.value }}</p>
      </div>
    }

    @if (properties().description) {
      <div class="col-span-full">
        <p class="text-text-secondary">Description</p>
        <p>{{ properties().description }}</p>
      </div>
    }
  </div>
</div>
